import React from "react"

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  rowsPerPage,
  totalRows,
  onRowsPerPageChange,
  siblingCount = 2,
}) {
  // build the sliding window of page numbers
  let start = Math.max(1, currentPage - siblingCount)
  let end = Math.min(totalPages, currentPage + siblingCount)

  if (end - start < siblingCount * 2) {
    start = Math.max(1, end - siblingCount * 2)
    end = Math.min(totalPages, start + siblingCount * 2)
  }

  const pages = []
  for (let p = start; p <= end; p++) pages.push(p)

  return (
    <div
      className="faxes-pagination"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        flexWrap: "wrap",
      }}
    >
      {/* Rows Per Page Dropdown */}
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <label htmlFor="rowsPerPage" style={{ fontSize: "12px" }}>
          Faxes per page:
        </label>
        <select
          id="rowsPerPage"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          style={{
            padding: "5px 36px 5px 8px",
            fontSize: "12px",
            fontFamily: "Montserrat, sans-serif", // ✅ explicitly apply here
            outline: "none",
            border: "1px solid #ccc",
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundColor: "#fff",
            backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='%23999' height='22' viewBox='0 0 24 24' width='22' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 6px center",
            backgroundSize: "22px",
          }}
        >
          {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
            <option key={count} value={count}>
              {count}
            </option>
          ))}
        </select>
      </div>

      {/* Pagination Controls */}
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <span className="faxes-page-info" style={{ fontSize: "12px" }}>
          Total Pages: {totalPages}
        </span>

        <span className="faxes-page-info" style={{ fontSize: "12px" }}>
          Total Faxes: {totalRows}
        </span>

        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          First
        </button>

        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {pages.map((p) => (
          <button
            key={p}
            className={`faxes-pagination-button page${
              p === currentPage ? " active" : ""
            }`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}

        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>

        <button
          className="faxes-pagination-button"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          Last
        </button>
      </div>
    </div>
  )
}
